/**
 * @generated SignedSource<<1125218262fb3601e74fcee8943def82>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentTypeGeneralInfoPanel_assignmentType",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        }
    ],
    "type": "AssignmentType",
    "abstractKey": null
};
node.hash = "fc052852dc6f95b6d657758ee96e2b60";
export default node;
